import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useToastController, Toast, ToastBody, ToastTitle } from '@fluentui/react-components';
import useUser from '../../hooks/useUser';
import useLocationState from '../../hooks/useLocationState';
import ViewPort from "../Layout/ViewPort"
import { Debug, LoadingAnimation, ManageJournal, ssToast } from 'ss-lib';
import { LoadData, UpdateData } from './actions';
import { CreateSubmissionSet } from '../SubmissionPortal/Manager/actions';

const pathKey = "/submissions/manager";

export const JournalManagerComponent = props => {
    const { user, saveUser, setTitle } = useUser();
    const [group, setGroup] = useState(user.current && user.current.scholarsift && user.current.scholarsift.groupPrefs ? user.current.scholarsift.groupPrefs[0] : undefined)
    const location = useLocation();
    const [domain, setDomain] = useState("");
    const [doneLoading, setDoneLoading] = useState(false);
    const [groups, setGroups] = useState();
    const [templates, setTemplates] = useState();
    const [users, setUsers] = useState();
    const { dispatchToast } = useToastController(ssToast);

    useEffect(() => {
        setTitle("Journal Manager");
        document.title = "Journal Manager";
    })

    useEffect(() => {
        console.log("Setting Group")
        setGroup(user.current && user.current.scholarsift && user.current.scholarsift.groupPrefs ? user.current.scholarsift.groupPrefs[0] : undefined);
    }, [user.current])

    useEffect(() => {
        //Load data
        LoadData(user, saveUser, setGroups, setTemplates, setUsers, setDomain, setDoneLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname])

    const Success = (msg, title) => {
        dispatchToast(<Toast appearance='inverted'><ToastTitle>{title ? title : "Success"}</ToastTitle><ToastBody>{msg}</ToastBody></Toast>, {intent: "information"})
    }

    const SaveGroup = v => {
        delete v.lid;
        UpdateData(user, saveUser, {
                lid: group.lid,
                type:"group", 
                data: {journal: group.journal, [pathKey]: v}
            }, 
            vv => {
                vv[pathKey].id = vv.id;
                vv[pathKey].lid = group.lid;
                Success("Saved Group"); 
                if(v.id === undefined || v.id < 0)
                    setGroups([...groups, vv[pathKey]]);
                else {
                    var g = groups.find(vv => v.id === vv.id);
                    Object.keys(v).forEach(k => g[k] = v[k]);
                    setGroups([...groups]);
                }

                var usr = {...user.current};
                var g = usr.scholarsift.groupPrefs.find(gp => gp.id === v.id);
                if(g) {
                    Object.keys(v).forEach(k => g[pathKey][k] = v[k]);
                    saveUser(usr);
                }
            }
        );
    }

    const SaveInfo = v => {
        UpdateData(user, saveUser, {
                lid: group.lid, 
                type:"info", 
                data: v
            }, 
            vv => {
                Success("Saved Info");
                setGroups(groups.map(g => {g.journal = vv.name; return g}))
            }
        );
    }

    const SaveTemplate = v => {
        UpdateData(user, saveUser, {
                lid: group.lid, 
                type:"template", 
                data: v
            }, 
            vv => { 
                Success("Saved Templates");
                if(v.id === undefined || v.id < 0)
                    setTemplates([...templates, v]);
                else {
                    var t = templates.find(vv => v.id === vv.id);
                    Object.keys(v).forEach(k => t[k] = v[k]);
                    setTemplates([...templates]);
                }
            }
        );
    }
    
    const SaveUser = v => {
        if(users.find(u => u.email === v.email) === undefined)
            Success("Creating User", "information");
        UpdateData(user, saveUser, {
                lid: group.lid, 
                type:"user", 
                data: v
            }, 
            vv => { 
                if(users.find(u => u.email === v.email) === undefined)
                {
                    Success("Created User"); 
                    setUsers([...users, vv]);
                }
                else {
                    Success("Saved User"); 
                    var u = users.find(vv => v.email === vv.email);
                    Object.keys(v).forEach(k => u[k] = v[k]);
                    setUsers([...users]);
                }    
            }
        );
    }

    const createSubmissionSet = set => {
        //Dispatch Toast
        dispatchToast(<Toast appearance='inverted'><ToastTitle>Creating Submission Set</ToastTitle><ToastBody>Creating {set.name}</ToastBody></Toast>, {intent: "information"});
    
        //Update API
        CreateSubmissionSet(user, saveUser, {...set, offset: new Date().getTimezoneOffset(), group: group.id}, (id) => {
    
            //Update States
            set.subset = id;
            if(Debug()) {
                console.log("CS Set")
                console.log(set)
            }
            
            var g = {...group, [pathKey]: {...group[pathKey], availableSets: group[pathKey].availableSets ? [...group[pathKey].availableSets, set] : [set]}};
            if(Debug()) {
                console.log("CS Set Group")
                console.log(g)
            }
            
            setGroup(g)
            var gp = [...groups];
            gp.forEach(v => {
                    if(v.name === group[pathKey].name) {
                        console.log("Found group");
                        v.availableSets.push(set);
                    }
            })
            if(Debug()) {
                console.log("CS Set Groups")
                console.log(gp)
            }
            setGroups(gp);
            var u = {...user.current};
            u.scholarsift.groupPrefs.forEach(v => {
                    if(v[pathKey].name === group[pathKey].name)
                        v[pathKey].availableSets.push(set);
            })
            if(Debug()) {
                console.log("CS Set User")
                console.log(u)
            }
            saveUser(u);
        
            //Dispatch Toast
            dispatchToast(<Toast appearance='inverted'><ToastTitle>Created Submission Set</ToastTitle><ToastBody>{set.name} is ready.</ToastBody></Toast>, {intent: "information"});
        });
    }

    if(Debug()) {
        console.log("Rendering")
        console.log("User")
        console.log(user.current)
        console.log("All Groups")
        console.log(groups)
        console.log("Group")
        console.log(group)
    }
    
    return  !doneLoading ?
            <LoadingAnimation msg="Loading"/> :
            <ManageJournal 
                height={props.height ? props.height * .75 : undefined}
                domain={domain}
                name={group ? group.journal : undefined}
                groups={groups}
                jid={group ? group.lid : undefined}
                SaveGroup={SaveGroup}
                SaveInfo={SaveInfo}
                templates={templates}
                SaveTemplate={SaveTemplate}
                users={users}
                SaveUser={SaveUser}
                createSubmissionSet={createSubmissionSet}
            />
}

export const JournalManager = (props) => {
    const { state } = useLocationState();
    const h = useRef();
    
    useEffect(() => {
        let v = state.viewport.h - (state.viewport.m + state.viewport.f + state.viewport.o);
        if (v !== h.current) h.current = v;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.viewport]);

    return  <ViewPort>
                <div style={{ minHeight: Math.max(0, (isNaN(h.current) ? 0 : h.current - 10))}}>
                    <JournalManagerComponent {...props} height={h.current} />
                </div> 
            </ViewPort>
}